export enum ACTION_TYPES {
  PUSH = 'CM/CASE/HISTORY/PUSH',
}
